import template from './garage-status.jade';
import items from '../../../enums/garage-status';

export default angular.module('cian.addForm.garageStatus', []).directive('cianAfAboutObjectGarageStatus', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.items = items;
  },
  controllerAs: 'garageStatus',
  template,
})).name;
